import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
export default function ImgMediaCard(props) {
    return (React.createElement(Card, { sx: { maxWidth: 300 } },
        React.createElement(CardMedia, { component: "img", alt: "avatar", height: "340", image: props.photoLink }),
        React.createElement(CardContent, null,
            React.createElement(Typography, { gutterBottom: true, variant: "h5", component: "div", sx: { textAlign: 'center' } },
                React.createElement("a", { href: props.href }, props.name)),
            React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { textAlign: 'center' } }, props.description))));
}
